// extracted by mini-css-extract-plugin
export default {"main":"Flexgrid_main__pxRKK","side":"Flexgrid_side__eWC4M"};